var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"loader-overlay"},[_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":require("@/assets/images/logo-white.png"),"alt":"logo"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }